exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-common[data-v-141e7ee9] {\n  margin-right: 5px;\n}\n", ""]);

// exports
